<template>
  <div class="d-flex pa-2 full-width overflow-hidden">
    <div
      class="flex-grow-1 flex-shrink-1 d-flex flex-column full-width overflow-hidden"
    >
      <div class="font-weight-bold text-truncate full-width" :title="item.name">
        {{ item.name }}
      </div>
      <div class="d-flex flex-wrap">
        <div class="d-flex align-center pr-4">
          <v-icon>mdi-folder</v-icon>
          <div class="pa-1 pr-0 text-truncate" :title="item.workspace.name">
            {{ item.workspace.name }}
          </div>
        </div>
        <div class="d-flex align-center">
          <v-icon>mdi-checkbox-blank</v-icon>
          <div class="pa-1 pr-0">{{ item.type }}</div>
        </div>
      </div>
    </div>
    <div class="pl-2 d-flex align-center flex-grow-0 flex-shrink-0">
      <base-button
        type-action="delete"
        icon
        @click="onDeleteItem"
      ></base-button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    item: { type: Object, default: () => ({}), required: true },
  },
  data: () => ({}),
  computed: {},
  methods: {
    onDeleteItem() {
      this.$emit('click:delete', this.item)
    },
  },
}
</script>

<style scoped></style>
